import React from 'react';
import { Link } from 'react-router-dom';
import { 
  TrendingUp, 
  Mail, 
  Phone, 
  MapPin,
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  Youtube
} from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { name: 'About Us', href: '/about' },
      { name: 'Services', href: '/services' },
      { name: 'Copy Trading', href: '/copy-trading' },
      { name: 'Contact Us', href: '/contact' }
    ],
    platform: [
      { name: 'Trading Platform', href: '/' },
      { name: 'Mobile App', href: '/' },
      { name: 'Web Platform', href: '/' },
      { name: 'API Access', href: '/services' }
    ],
    markets: [
      { name: 'Stock Trading', href: '/stock-trading' },
      { name: 'Cryptocurrency', href: '/crypto-trading' },
      { name: 'Forex Trading', href: '/services' },
      { name: 'Commodities', href: '/services' }
    ],
    legal: [
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Terms of Service', href: '/terms' },
      { name: 'Contact Support', href: '/contact' },
      { name: 'Security', href: '/contact' }
    ]
  };

  const socialLinks = [
    { name: 'Facebook', icon: Facebook, href: 'https://facebook.com' },
    { name: 'Twitter', icon: Twitter, href: 'https://twitter.com' },
    { name: 'LinkedIn', icon: Linkedin, href: 'https://linkedin.com' },
    { name: 'Instagram', icon: Instagram, href: 'https://instagram.com' },
    { name: 'YouTube', icon: Youtube, href: 'https://youtube.com' }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Main Footer Content */}
        <div className="footer-main">
          
          {/* Company Info */}
          <div className="footer-company">
            <Link to="/" className="footer-logo">
              <div className="footer-logo-icon">
                <TrendingUp className="footer-logo-svg" />
              </div>
              <span className="footer-logo-text">ChartLine</span>
            </Link>
            <p className="footer-company-description">
              Empowering traders worldwide with cutting-edge technology, 
              competitive pricing, and unparalleled customer service.
            </p>
            
            {/* Contact Info */}
            <div className="footer-contact">
              <div className="footer-contact-item">
                <Mail className="footer-contact-icon" />
                <span>info@chartlinebrokerage.com</span>
              </div>
              <div className="footer-contact-item">
                <Phone className="footer-contact-icon" />
                <span>+1 239 791 0799</span>
              </div>
              <div className="footer-contact-item">
                <MapPin className="footer-contact-icon" />
                <span>2268 S Tongass Hwy, Ketchikan, AK 99901</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="footer-social">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link"
                  aria-label={social.name}
                >
                  <social.icon className="footer-social-icon" />
                </a>
              ))}
            </div>
          </div>

          {/* Footer Links */}
          <div className="footer-links">
            <div className="footer-links-column">
              <h3 className="footer-links-title">Company</h3>
              <ul className="footer-links-list">
                {footerLinks.company.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="footer-link">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-links-column">
              <h3 className="footer-links-title">Platform</h3>
              <ul className="footer-links-list">
                {footerLinks.platform.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="footer-link">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-links-column">
              <h3 className="footer-links-title">Markets</h3>
              <ul className="footer-links-list">
                {footerLinks.markets.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="footer-link">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-links-column">
              <h3 className="footer-links-title">Legal</h3>
              <ul className="footer-links-list">
                {footerLinks.legal.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="footer-link">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {currentYear} ChartLine Brokerage. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <Link to="/privacy" className="footer-bottom-link">
                Privacy Policy
              </Link>
              <Link to="/terms" className="footer-bottom-link">
                Terms of Service
              </Link>
              <a 
                href="https://dashboard.chartlinebrokerage.com"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-bottom-link"
              >
                Trading Dashboard
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 